module.exports = __webpack_public_path__ + "img/pas.7d3def47.svg";